// Path helpers for shareable pipeline item links, mirroring the
// customerConversationRoutes conventions.

/**
 * Builds the canonical path for a pipeline item: /pipeline/item/127.
 *
 * `_business` is carried as ?_location= for parity with conversation links
 * and future multi-location support. The current client does not consume it —
 * cross-business links resolve to a clean not-found toast — but including it
 * in server-generated links (emails) means old links start working the day
 * location-switching lands.
 */
export const buildPipelineItemPath = ({
	itemNumber,
	_business,
}: {
	itemNumber: number | string;
	_business?: string;
}): string =>
	`/pipeline/item/${itemNumber}${
		_business ? `?_location=${encodeURIComponent(_business)}` : ''
	}`;
